<template>
  <MilestonesSideBarContent
    :milestones="getPMileStones(project_id)"
    :show_details="
      [
        'ProjectMilestonesDetails',
        'ProjectMilestonesEdit',
        'ProjectMilestonesAdd'
      ].includes($route.name)"
    >
    <template #list="{milestones}">
      <MilestoneListEntry
        v-for="pmilestone in milestones"
        :key="pmilestone.pmilestone.id"
        :color="$route.params.pmilestone_id === pmilestone.pmilestone.id?'color-3':''"
        @click.native="$router.push({name: 'ProjectMilestonesDetails', params: {pmilestone_id: pmilestone.pmilestone.id}})"
        >
        <MileStone
          class="ml-4 mt-7"
          :token="pmilestone.pmilestone.token"
          :status="getProjectMilestoneStatus({id: pmilestone.pmilestone.id, takt_index: pmilestone.takt_index, project_id})"
          type="project"
          :large="true"
          />
        <div class="ml-12">{{pmilestone.pmilestone.name}}</div>
        <v-spacer/>
        <div>{{pmilestone.pmilestone.date.substring(0,10)}}</div>
      </MilestoneListEntry>
      <MilestoneListEntry
        style="position: sticky; bottom: 0px; z-index: 50"
        v-if="isEditMode"
        :color="![
          'ProjectMilestonesDetails',
          'ProjectMilestonesEdit'
        ].includes($route.name) ? 'color-3' : ''"
        @click.native="$router.push({name: 'ProjectMilestonesAdd'})"
        >
        <v-icon class="ml-2">add</v-icon>
        <div
          class="ml-12"
          >
          {{$t('Project.Milestones.Project.AddProjectMilestone')}}
        </div>
      </MilestoneListEntry>
    </template>
    <template #details>
      <router-view/>
    </template>
  </MilestonesSideBarContent>
</template>
<script>
  import MilestonesSideBarContent from '@/components/ProjectTaktPlan/MilestonesSideBarContent.component.vue'

  import { MilestonesMixin } from '@/mixins/Milestones.mixin.js'

  export default {
    props: ['project_id'],
    components:{
      MilestonesSideBarContent,
    },
    mixins: [
      MilestonesMixin
    ],
  }
</script>
